'use client'

import { AllPurposeLink } from '@components/all-purpose-link'
import { gridItemTransition } from '@components/grid'
import { trackButtonClicked, TrackedButtonNames } from '@utils/analytics'
import { marketplaceTokenRoute } from '@utils/routes'
import { BodyText, DetailText } from 'design-configuration/components'
import { ImageWithCustomLoader } from '@components/image-with-custom-loader'
import { motion } from 'motion/react'
import { useState } from 'react'
import { cn } from '@/lib/utils'
import { buttonVariants } from '@components/button'
import { Listing, Platform } from '@/mongo/services/activity/types'
import { getVerticalTitleFromMongoPlatform } from '@utils/project'

export const RecentListingCard = ({ listing }: { listing: Listing }): React.ReactElement => {
  const [opacity, setOpacity] = useState(0)

  // if (!token) return <></>
  return (
    <motion.div
      className="group relative h-full w-full"
      key={listing.assetId}
      id={listing.assetId}
      layout
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={gridItemTransition}
    >
      <AllPurposeLink
        href={marketplaceTokenRoute(listing.contractAddress, listing.tokenId)}
        onClick={() => {
          trackButtonClicked(TrackedButtonNames.recentListingToken, {
            token: {
              token_id: listing.tokenId
            },
            customProperties: {
              Name: listing.asset.name,
              Artist: listing.artist.name,
              Price: listing.priceInEth,
              Platform: getVerticalTitleFromMongoPlatform(listing.assetCollection.platform as Platform)
            }
          })
        }}
        className="relative flex h-full w-full flex-col items-center justify-start text-center"
      >
        <motion.div
          className={`bg-surface-low relative flex aspect-square h-auto w-full rounded-[2px]`}
          layout
          transition={{ duration: 0.3 }}
          animate={{ opacity: opacity }}
        >
          <motion.div
            className="relative h-full w-full"
            layout
            transition={{ duration: 0.3 }}
            animate={{ opacity: opacity }}
          >
            <ImageWithCustomLoader
              onLoad={() => setOpacity(1)}
              src={listing?.asset?.imageUrl ?? ''}
              className="p-md drop-shadow-[3px_3px_6px_rgba(0,0,0,0.20)] transition-all duration-300 hover:scale-[1.01] hover:drop-shadow-[3px_5px_7px_rgba(0,0,0,0.20)]"
              fill
              style={{
                objectFit: 'contain',
                objectPosition: 'center'
              }}
              alt={`Featured token for: ${listing?.asset?.name}`}
              sizes="33vw"
            />
          </motion.div>
        </motion.div>
        <motion.div
          layout="position"
          transition={{ duration: 0.3 }}
          className="mt-md gap-sm flex flex-col items-center justify-center"
        >
          <div className="gap-2xs flex flex-col items-center justify-center">
            <DetailText className="text-on-surface-variant font-medium uppercase">
              {getVerticalTitleFromMongoPlatform(listing.assetCollection.platform as Platform)}
            </DetailText>
            <BodyText className="font-medium">{listing.asset.name}</BodyText>
            <BodyText>{listing.artist.name}</BodyText>
          </div>
          <BodyText className="font-medium">{listing.priceInEth} Ξ</BodyText>
          <div
            className={cn(
              buttonVariants({
                colorTheme: 'outline'
              })
            )}
          >
            <BodyText asChild>
              <span>Purchase</span>
            </BodyText>
          </div>
        </motion.div>
      </AllPurposeLink>
    </motion.div>
  )
}
